import { Door, DoorBatteryWarningLevel, DoorType } from 'graphql/generated/graphqlTypes';
import { generateMockWeekSchedule } from './weekSchedule';

export function generateMockDoor({
  batteryWarningLevel = DoorBatteryWarningLevel.BatteryUnknown,
  hardwareIdentifier = 'mockedHardwareIdentifier',
  locations = [],
  id = 'mockDoorId',
  name = 'mockDoorName',
  officeMode = generateMockWeekSchedule({}),
  supportsOssCards = false,
  taReaderId = 'mockDoorTaReaderId',
  type = DoorType.DomController
}: Partial<Omit<Door, '__typename'>>): Door {
  return {
    __typename: 'Door',
    batteryWarningLevel,
    hardwareIdentifier,
    locations,
    id,
    locationIds: locations.map((l) => l.id),
    name,
    officeMode,
    supportsOssCards,
    taReaderId,
    type
  };
}
